export enum EmissionTypeEnum {
  EMISSION_FACTOR = "emissionFactor",
  STACK_SAMPLING = "stackSampling",
}
export interface OptionFilterItem {
  key: string;
  filter: (number | string)[];
}

export interface OptionFilterCombustion {
  filter: OptionFilterItem[];
}

export interface FilterCombustion {
  stackId?: number[] | null;
  sourceId?: number[] | null;
  area?: number[] | null;
  fuelType?: number[] | null;
  fuelName?: number[] | null;
  calculationMethod?: string[] | null;
}

export interface Emission {
  tvoc: boolean;
  bz: boolean;
  bd: boolean;
  vcm: boolean;
  edc: boolean;
}

export interface ResponseAPI {
  code: number;
  status: string;
  name: string;
  message: string;
  data: {
    combustions: CombustionStackInfo[];
    total: number;
  };
}

export interface ResponseYearsOfCombustion {
  code: number;
  status: string;
  name: string;
  message: string;
  data: [];
}

export interface dropdownOption {
  label: string;
  value: string;
}

export interface Filter {
  text: string;
  value: string;
}

export interface CombustionStackInfo {
  _id?: string;
  companyId: string;
  stackId: number | "";
  sourceId: number | "";
  area: string;
  fuelName: string;
  fuelType: string;
  calculationMethod: string;
  emission: Emission | {};
  year: number | "";
  isFlowActive?: boolean;
}

export interface MasterData {
  _id: string;
  type: string;
  label: string;
  options: dropdownOption[];
}

export const resetCombustion: CombustionStackInfo = {
  companyId: "",
  stackId: "",
  sourceId: "",
  area: "",
  fuelName: "",
  fuelType: "",
  calculationMethod: "",
  emission: {
    tvoc: true,
    bz: false,
    bd: false,
    vcm: false,
    edc: false,
  },
  year: "",
};
